import React, { forwardRef, memo, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { useParams } from 'react-router-dom';

import RequestBankVerificationDialog from './RequestBankVerificationDialog';

import { AchActionProps } from './achVerificationTypes';

// RLPR-20420 transaction action: ask the user to relink the bank account of a pending ACH deposit through Stripe
const RequestBankVerificationField = forwardRef<HTMLLIElement, AchActionProps>((props, ref) => {
  const { record, hideAction } = props;

  const { id } = useParams<{ id: string }>();

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  if (hideAction) {
    return null;
  }

  return (
    <>
      <Tooltip title="Emails the user a portal link to relink the bank account with transactions access through Stripe">
        <MenuItem ref={ref} onClick={() => setOpenDialog(true)}>
          Request bank verification
        </MenuItem>
      </Tooltip>

      {openDialog && (
        <RequestBankVerificationDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          userId={id}
          record={record}
        />
      )}
    </>
  );
});

export default memo(RequestBankVerificationField);
